import React from 'react';
import {
    CategoryBrowseProviderProps,
    CategoryBrowseProviders,
} from './CategoryBrowseProviders';
import { THEMATIC_PAGE_ELIGIBLE_CATEGORIES } from './constants/seasonal';
import { CategoryBrowseBasePage } from './pages/CategoryBrowseBasePage';
import { CategoryBrowsePage } from './pages/CategoryBrowsePage';
import CategoryBrowseThemePage from './pages/CategoryBrowseThemePage';
import NightlifePage from './pages/NightlifePage';
import { SeasonalPage } from './pages/SeasonalPage';

const renderThematicPage = (category: string) => {
    return (
        THEMATIC_PAGE_ELIGIBLE_CATEGORIES.includes(category) &&
        CategoryBrowseThemePage
    );
};

const renderSeasonalPage = (
    category: string,
    enableSeasonalModule: boolean,
    subcategory?: string,
) => {
    return (
        category === 'holiday' &&
        enableSeasonalModule &&
        !subcategory &&
        CategoryBrowseThemePage
    );
};

export const CategoryBrowsePageWithProviders: React.FunctionComponent<
    CategoryBrowseProviderProps
> = (props) => {
    const { category, subcategory } = props.match.params;
    const TagAsCategoryPages: { [key: string]: React.FunctionComponent } = {
        nightlife: props.featureFlags?.enableNightlifeThematicPage
            ? CategoryBrowseThemePage
            : NightlifePage,
        ...(props.featureFlags?.enableSeasonalModule && {
            seasonal: SeasonalPage,
        }),
    };

    const BrowsePage =
        renderSeasonalPage(
            category,
            props.featureFlags?.enableSeasonalModule ?? false,
            subcategory,
        ) ||
        renderThematicPage(subcategory || category) ||
        TagAsCategoryPages[subcategory || category] ||
        CategoryBrowsePage;
    return (
        <CategoryBrowseProviders
            match={props.match}
            location={props.location}
            history={props.history}
            location_data={props.location_data}
            location_slug={props.location_slug}
            featureFlags={props.featureFlags}
        >
            <CategoryBrowseBasePage {...props}>
                <BrowsePage />
            </CategoryBrowseBasePage>
        </CategoryBrowseProviders>
    );
};

export default CategoryBrowsePageWithProviders;
